import {DeprecatedDataFrame} from 'data-frames/DataFrameTypes';

/**
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function filterRows<TDataRow>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  predicate: (dataRow: TDataRow, index: number) => boolean
): DeprecatedDataFrame<TDataRow> {
  return {
    ...dataFrame,
    points: dataFrame.points.filter((dataRow, index) => predicate(dataRow, index)),
  };
}
